import { GADataProps } from "@components/GAData/GAData";
import DefaultLayout from "@routes/Section/layouts/DefaultLayout/DefaultLayout";
import ThrivePage from "@routes/Section/layouts/Thrive/ThrivePage";
import VerticalsLatestPageContent from "@routes/Section/layouts/Verticals/VerticalsLatestPageContent";
import VerticalsPageContent from "@routes/Section/layouts/Verticals/VerticalsPageContent";
import { SectionPageData } from "@routes/Section/utils/types";

type SectionPageContentProps = SectionPageData & {
  gaProps: GADataProps;
};
/** The content of the section page. Separated by template. */
const SectionPageContent = ({
  gaProps,
  ...data
}: SectionPageContentProps): React.ReactElement => {
  switch (data.template) {
    case "verticals":
      return <VerticalsPageContent {...data} gaProps={gaProps} />;

    case "verticalsLatest":
      return <VerticalsLatestPageContent {...data} gaProps={gaProps} />;

    case "thrive":
      return <ThrivePage {...data} gaProps={gaProps} />;

    case "default":
    default:
      return <DefaultLayout {...data} gaProps={gaProps} />;
  }
};

export default SectionPageContent;
